import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, PLATFORM_ID } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CoordinatesDto } from '@aoe/client';
import { divIcon, LatLng, map, marker, Marker, tileLayer } from 'leaflet';

@Component({
  selector: 'aoe-map-selector',
  imports: [MatDialogModule],
  templateUrl: './map-selector.component.html',
  styleUrl: './map-selector.component.scss'
})
export class MapSelectorComponent implements AfterViewInit {

  public isBrowser = isPlatformBrowser(this.platformId);
  private map!: L.Map;
  // private L: any;
  private poiteurMarker?: Marker

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    @Inject(MAT_DIALOG_DATA) public data: { coordinates: CoordinatesDto | null },
    readonly dialogRef: MatDialogRef<MapSelectorComponent>
  ) {
  }

  ngAfterViewInit(): void {
    this.initMap();
    if (this.data.coordinates?.lat && this.data.coordinates.lng)
      this.addMarker(this.data.coordinates.lat, this.data.coordinates.lng);
    this.map.on('click', (e) => {
      const coord = e.latlng;
      if (this.poiteurMarker) {
        this.poiteurMarker.setLatLng(new LatLng(coord.lat, coord.lng));
      } else {
        this.addMarker(coord.lat, coord.lng);
      }
      this.data.coordinates = new CoordinatesDto(coord.lat, coord.lng);
    });
  }

  get coordinates() {
    return this.data.coordinates;
  }

  private initMap(): void {

    const coordinatesCenterMap = () => {
      if (this.data.coordinates?.lat && this.data.coordinates?.lng)
        return new LatLng(this.data.coordinates.lat, this.data.coordinates.lng);
      return new LatLng(43.701220, 7.267669)
    };

    this.map = map('map', {
      zoom: 13,
      scrollWheelZoom: true,
      center: coordinatesCenterMap()
    });


    const tiles = tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 17,
      minZoom: 3,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">Open Street Map</a>'
    });

    tiles.addTo(this.map);
  }

  private addMarker(lat: number, lng: number): void {
    this.poiteurMarker = marker([lat, lng], {
      icon: divIcon(
        {
          html: `
              <div
              style="width: 30px !important;
              height: 30px !important;
              background-image: url('../../assets/icons/svg/pin.svg');
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              border-radius: 10px;">
              </div>`,
          iconSize: [0, 0],
          iconAnchor: [20, 30]
        })
    }).addTo(this.map);
  }
};
